import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";

import Select from "react-select";
import { Select2Data } from "../../../utils/api";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

 const GetEditData = async () => {
  const response = await getData(`/search-history/${id}`);

  if (response?.success) {
    const seller_ids =
      response.data?.serach_history_sellers?.map((item) =>
        Number(item.seller_id)
      ) || [];

    reset({
      ...response.data,
      seller_ids,
    });
  }
};


  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("seller_ids", JSON.stringify(data.seller_ids));
      const response = await postData(`/search-history/${id}`, sendData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [product, setProducts] = useState([]);
  const GetAllProduct = async () => {
    const response = await getData("/all-products");

    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  const [sellers, setSellers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const GetAllSellers = async () => {
    const response = await getData("/all-sellers"); // API should return sellers
    if (response?.success) {
      setSellers(response.data);
    }
  };

  useEffect(() => {
    GetAllSellers();
  }, []);

 const sellerIds = (watch("seller_ids") || []).map(Number);



  console.log(sellerIds,"sellerIds sellerIds");
  
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      setValue(
        "seller_ids",
        sellers.map((s) => Number(s.id))
      );
    } else {
      setValue("seller_ids", []);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Seller
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="mt-3">
              <Col md={12}>
                <Form.Label>Sellers</Form.Label>

                {/* Select All */}
                <Form.Check
                  type="checkbox"
                  label="Select All Sellers"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="mb-2 fw-bold"
                />

                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  {sellers.map((seller) => (
                    <Form.Check
                      key={seller.id}
                      type="checkbox"
                      label={seller.first_name}
                      value={seller.id}
                      {...register("seller_ids")}
                      checked={sellerIds.includes(Number(seller.id))}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (e.target.checked) {
                          setValue("seller_ids", [...sellerIds, value]);
                        } else {
                          setValue(
                            "seller_ids",
                            sellerIds.filter((id) => id !== value)
                          );
                          setSelectAll(false);
                        }
                      }}
                    />
                  ))}
                </div>

                {errors.seller_ids && (
                  <span className="text-danger">
                    {errors.seller_ids.message}
                  </span>
                )}
              </Col>
            </Row>
            <div className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
